import request from '@/utils/request'

export const getFixedAssets = params => request.get('/accounting/fixed-assets', { params })

export const createFixedAsset = data => request.post('/accounting/fixed-assets', data)

export const getFixedAsset = id => request.get(`/accounting/fixed-assets/${id}`)

export const updateFixedAsset = (id, data) => request.put(`/accounting/fixed-assets/${id}`, data)

export const deleteFixedAsset = id => request.delete(`/accounting/fixed-assets/${id}`)

export const getFixedAssetStatement = params => request.get('/accounting/reports/fixed-assets', { params })

export const getDepreciationRuns = params => request.get('/accounting/depreciation-runs', { params })

export const previewDepreciation = params => request.get('/accounting/depreciation-runs/preview', { params })

export const createDepreciationRun = data => request.post('/accounting/depreciation-runs', data, { rawResponse: true })

export const getDepreciationRun = id => request.get(`/accounting/depreciation-runs/${id}`)

export const reverseDepreciationRun = id => request.post(`/accounting/depreciation-runs/${id}/reverse`)
